export const INDEX_KEY = {
  expPV: 'seckillAmt',
};

export const INDEX_GROUP = [
  {
    label: '京东秒杀',
    value: INDEX_KEY.expPV,
  },
];

export const INDEX_GROUP_MAP = {};

function transformArr2Map(data = [], res = {}) {
  data.forEach((item) => {
    res[item.value] = item.label;
  });
}
transformArr2Map(INDEX_GROUP, INDEX_GROUP_MAP);

export const DEFAULT_INDEX = [INDEX_KEY.expPV];

export const COLORS = [
  '#4864B5',
  '#409FFF',
  '#14BFBF',
  '#26BF27',
  '#A9D917',
  '#FFC802',
  '#FF8C19',
  '#F26130',
  '#bec4e2',
  '#415c8a',
];
